import React from 'react';
import {
  DateField,
  ListBase,
  ListToolbar,
  Pagination,
  Datagrid,
  Title,
} from 'react-admin';

import { Divider, Card, makeStyles } from '@material-ui/core';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import Textofield from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { stylesMalote } from '../../utils';
import { PERMISSAO_TELA_SINISTROS_LISTAR } from '../../utils/dadosTelas';
import ValorTransferenciaField from '../Transacoes/Fields/ValorTransferenciaField';
import CodigoField from './Fields/CodigoField';
import Filter from './Filter';

const useStylesDatagrid = makeStyles((theme) => stylesMalote);

const PostPanel = (props) => (
  <div>{`Descrição: ${props.record.descricao}`}</div>
);

const MyList = ({ ...props }) => {
  const classes = useStylesDatagrid();

  return (
    <>
      <Title title="Sinistros" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Divider />
        <div>
          <Datagrid {...props}>
            <CodigoField
              source="codigo"
              label="Código"
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
              sortable={false}
            />
            <DateField
              source="data_pagamento"
              label="Horário"
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
              options={{ hour: 'numeric', minute: 'numeric' }}
              sortable={false}
            />
            <Textofield
              label="Responsável"
              source=".responsavel.username"
              sortable={false}
              headerClassName={classes.dataHeader}
              cellClassName={classes.categoriaCell}
            />
            <ValorTransferenciaField
              source="valor"
              textAlign="right"
              label="Valor"
              headerClassName={classes.dataHeader}
              cellClassName={classes.valorCell}
              sortable={false}
            />
          </Datagrid>
        </div>
        <TransacoesPagination />
      </Card>
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_SINISTROS_LISTAR}>
    <ContainerMyList
      {...props}
      expand={<PostPanel />}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Sinistros"
    />
  </ProtegerPagina>
);

export default List2;
